import TuneIcon from '@mui/icons-material/Tune'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import MapIcon from '@mui/icons-material/Map'
import OverigeDataStadList from './OverigeDataStadList'
import OverigeDataGebiedList from './OverigeDataGebiedList'

const stad = {
  list: OverigeDataStadList,
  icon: LocationCityIcon,
}

const gebied = {
  list: OverigeDataGebiedList,
  icon: MapIcon,
}

const groupIcon = TuneIcon

export { stad, gebied, groupIcon }
export default { stad, gebied, groupIcon }
